import React from 'react';
import '../styles/NoMatchModal.css';

function NoMatchModal(props) {
    const propertyInfoCompare = props.propertyInfoCompare;
    const externalCompanyNoMatch = props.externalCompanyNoMatch;
    const selectedOption = props.selectedOption;
    const setSelectedOption = props.setSelectedOption;
    const setBedrooms = props.setBedrooms;
    const setBathrooms = props.setBathrooms;
    const setSquareFootage = props.setSquareFootage;
    const setYearBuilt = props.setYearBuilt;
    const setAdu = props.setAdu;
    const setPool = props.setPool;
    const setGarage = props.setGarage;
    const setGarageSpaces = props.setGarageSpaces;
    const setGarageType = props.setGarageType;
    const setBasement = props.setBasement;
    const setBelowGradeSquareFootage = props.setBelowGradeSquareFootage;

    const selectOption = (index) => {
        setSelectedOption(index);

        const relevantObject = index === 0 ? propertyInfoCompare.old : propertyInfoCompare.new;
        
        // First, find and set basement value to track it
        let basementValue = null;
        relevantObject.forEach((item) => {
            if (item.label === "Basement") {
                basementValue = Boolean(item.rawValue);
            }
        });
        
        // Update all fields dynamically based on label
        relevantObject.forEach((item) => {
            const label = item.label;
            const rawValue = item.rawValue;
            
            if (label === "Beds") {
                setBedrooms(Number(rawValue));
            } else if (label === "Baths") {
                setBathrooms(Number(rawValue));
            } else if (label === "Square footage") {
                setSquareFootage(Number(rawValue));
            } else if (label === "Year built") {
                setYearBuilt(Number(rawValue));
            } else if (label === "ADU") {
                setAdu(Boolean(rawValue));
            } else if (label === "Pool") {
                setPool(Boolean(rawValue));
            } else if (label === "Garage") {
                // Handle combined garage field - rawValue is now an object with garage, garageSpaces, garageType
                if (typeof rawValue === 'object' && rawValue !== null) {
                    setGarage(Boolean(rawValue.garage));
                    // Only set garage spaces if garage is true, otherwise reset to default
                    if (rawValue.garage === true && rawValue.garageSpaces !== null && rawValue.garageSpaces !== undefined) {
                        setGarageSpaces(Number(rawValue.garageSpaces));
                    } else {
                        setGarageSpaces(1);
                    }
                    // Only set garage type if garage is true, otherwise reset to null
                    if (rawValue.garage === true && rawValue.garageType !== null && rawValue.garageType !== undefined) {
                        setGarageType(rawValue.garageType);
                    } else {
                        setGarageType(null);
                    }
                } else {
                    // Fallback for old format
                    setGarage(Boolean(rawValue));
                }
            } else if (label === "Basement") {
                setBasement(Boolean(rawValue));
            } else if (label === "Below grade square footage") {
                // Only set below grade square footage if basement is true, otherwise set to 0
                if (basementValue === true) {
                    setBelowGradeSquareFootage(Number(rawValue));
                } else {
                    setBelowGradeSquareFootage(0);
                }
            }
        });
    };

    return (
        <div className="no-match-modal-container">
            {
                externalCompanyNoMatch === true ?
                <span className="body-regular colour-primary">
                    Another business has run this property before but with <span className="body-bold">different</span> property info. 
                    Please double check and select the <span className="body-bold">correct configuration</span> to run this report with.
                </span>
                :
                <span className="body-regular colour-primary">
                    You or your team have already run this property, but with different property info. 
                    You can either view the old report, or re-run the report with the new property info for{" "}
                    <span className="body-bold">
                        1 extra credit.
                    </span>
                </span>
            }
            <div className="no-match-modal-row">
                <div 
                    className={"no-match-modal-element cursor-pointer " + (selectedOption === 0 ? "no-match-modal-element-selected" : "")}
                    onClick={() => selectOption(0)}
                >
                    <div className="no-match-modal-element-inner-container">
                        <span className="heading-small-bold colour-primary">
                            Old info
                        </span>
                        {
                            propertyInfoCompare.old.map((item, index) =>
                                <div 
                                    className="no-match-modal-characteristic relative-container"
                                    key={index}
                                >
                                    <div className="no-match-modal-characteristic-label">
                                        <span className="body-regular colour-primary">
                                            {item.value}
                                        </span>
                                    </div>
                                </div>
                            )
                        }
                    </div>
                </div>
                <div 
                    className={"no-match-modal-element cursor-pointer " + (selectedOption === 1 ? "no-match-modal-element-selected" : "")}
                    onClick={() => selectOption(1)}
                >
                    <div className="no-match-modal-element-inner-container">
                        <span className="heading-small-bold colour-primary">
                            You indicated...
                        </span>
                        {
                            propertyInfoCompare.new.map((item, index) =>
                                <div 
                                    className="no-match-modal-characteristic relative-container"
                                    key={index}
                                >
                                    <span className="body-regular colour-primary">
                                        {item.value}
                                    </span>
                                    {
                                        // Only show difference for numeric fields (not garage which is now an object)
                                        typeof item.rawValue === 'number' && 
                                        typeof propertyInfoCompare.old[index].rawValue === 'number' &&
                                        item.rawValue !== propertyInfoCompare.old[index].rawValue &&
                                        <span className="body-bold colour-error no-match-modal-difference">
                                            {item.rawValue - propertyInfoCompare.old[index].rawValue > 0 ? "+" : ""}
                                            {Number((item.rawValue - propertyInfoCompare.old[index].rawValue).toFixed(2))}
                                        </span>
                                    }
                                    {
                                        // For garage (object), show difference indicator if values differ
                                        item.label === "Garage" &&
                                        typeof item.rawValue === 'object' &&
                                        typeof propertyInfoCompare.old[index].rawValue === 'object' &&
                                        (item.rawValue.garage !== propertyInfoCompare.old[index].rawValue.garage ||
                                         item.rawValue.garageSpaces !== propertyInfoCompare.old[index].rawValue.garageSpaces ||
                                         item.rawValue.garageType !== propertyInfoCompare.old[index].rawValue.garageType) &&
                                        <span className="body-bold colour-error no-match-modal-difference">
                                            (changed)
                                        </span>
                                    }
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>
        </div>
    )
};

export default NoMatchModal;